var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showScenarioTemplates ? _vm._m(0) : _vm._e(),
      _vm._v(" "),
      _vm.showChangeInfo ? _vm._m(1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("scenario-templates", {
      attrs: { scenarioIds: _vm.scenarioIds },
      on: {
        "trigger-change-info": function($event) {
          _vm.currentComponent = _vm.changeInfoComponent
        }
      }
    })
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("change-info", {
      on: {
        "cancel-change-info": function($event) {
          _vm.currentComponent = _vm.scenarioTemplatesComponent
        }
      }
    })
  }
]
render._withStripped = true

export { render, staticRenderFns }